import type { CfoCurrentStatementMetadata } from '../../../data/ServerApiClient'

function partialMonthCutoff(end?: string | null): string | null {
  const parts = typeof end === 'string' && /^(\d{4})-(\d{2})-(\d{2})$/.exec(end)
  if (!parts) return null
  const [year, month, day] = parts.slice(1).map(Number)
  const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)
  const lastDay = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month - 1]
  if (year < 1 || !lastDay || day < 1 || day >= lastDay) return null
  return new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
    .format(new Date(`${end}T00:00:00Z`))
}

export function CfoCurrentSourceNotice({ source }: { source?: CfoCurrentStatementMetadata | null }) {
  if (!source) return null
  const cutoff = partialMonthCutoff(source.selected_period_end)
  return <div className="cfo-shell-notice" role="status">
    {cutoff && <>Partial month: figures through {cutoff}.{' '}</>}
    {source.native_profit_and_loss_validated && source.native_balance_sheet_validated
      ? 'P&L and balance sheet checked against QuickBooks.'
      : 'Statement validation is incomplete.'}
    {' '}{source.general_ledger_verified
      ? 'Transaction detail verified.'
      : 'Transaction detail is not verified for this update.'}
    {!source.native_cash_flow_validated && <><br />Cash flow is unavailable because its independent check has not passed.
      {source.cash_flow_unavailable_reason && <details><summary>Cash-flow check details</summary>{source.cash_flow_unavailable_reason}</details>}
    </>}
  </div>
}
